import { styled } from '@linaria/react';
import { colors, layout, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${layout.desktopBreakpoint}) {
    flex-direction: row;
  }
`;

export const LeftSide = styled.div`
  width: 100%;

  @media (min-width: ${layout.desktopBreakpoint}) {
    width: var(--split-left-width, 58%);
    height: var(--split-height, 90vh);
    flex-shrink: 0;
    position: sticky;
    top: 0;
    align-self: flex-start;
  }
`;

export const RightSide = styled.div<{ $mobileHorizontalPadding?: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: ${({ $mobileHorizontalPadding }) =>
    `${space[5]} ${$mobileHorizontalPadding ?? space[4]}`};
  box-sizing: border-box;
  overflow-x: clip;
  background: ${colors.white};
  border-radius: 20px 20px 0 0;
  margin-top: -24px;
  position: relative;
  z-index: 1;

  @media (min-width: ${layout.desktopBreakpoint}) {
    width: var(--split-right-width, 42%);
    padding: ${space[6]} ${space[8]} ${layout.horizontalPadding};
    border-radius: 0;
    margin-top: 0;
    z-index: auto;
    overflow-x: visible;
  }
`;

export const ContentInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: var(--split-content-max-width, 480px);
  gap: var(--split-content-gap, 64px);
  flex: 1;
  min-height: 0;
`;
